import pluralize from './dsb.mjs';

export default pluralize;
